export default {
    empty: '',
    obj: {
        first: {
            order: '第一题',
            testFlag: 1,
            title: '1. 回古代，你会选择哪种衣物避暑？',
            rightChoose: 'b',
            choose: {
                a: '雨蓑衣',
                b: '罗纱衣',
                c: '羽绒衣'
            },
            message: {
                error: {
                    title: '答错了',
                    des: '轻薄透气的纱是很合适的材料！'
                },
                right: {
                    title: '答对啦!',
                    des: '古代的罗纱衣透气好、能吸汗，和现代的防晒衣差不多哦！'
                }
            }
        },
        second: {
            order: '第二题',
            testFlag: 2,
            title: '2.以下哪个不是古代的冰箱？',
            rightChoose: 'c',
            choose: {
                a: '凌阴',
                b: '冰鉴',
                c: '冰盒'
            },
            message: {
                error: {
                    title: '答错了',
                    des: '冰盒的名称这么现代，怎么会是古代冰箱哇！'
                },
                right: {
                    title: '答对啦!',
                    des: '古代的凌阴、冰鉴都是用冰块降温的“冰箱”哦！'
                }
            }
        },
        third: {
            order: '第三题',
            testFlag: 3,
            title: '3.哪个材质的枕头最凉快？',
            rightChoose: 'b',
            choose: {
                a: '棉枕',
                b: '瓷枕',
                c: '毛枕'
            },
            message: {
                error: {
                    title: '答错了',
                    des: '偷偷告诉你：哪个看起来最贵就选哪个。'
                },
                right: {
                    title: '答对啦!',
                    des: '中空的瓷枕可以保持良好的通风，有降温的效果。'
                }
            }
        },
        fourth: {
            order: '第四题',
            testFlag: 4,
            title: '4.古代的自动风扇，需要以下哪些工具？(多选)',
            rightChoose: true,
            choose: [
                {
                    key: 'a',
                    value: '流水',
                    isChecked: false
                },
                {
                    key: 'b',
                    value: '竹板',
                    isChecked: false
                },
                {
                    key: 'c',
                    value: '绳子',
                    isChecked: false
                }
            ],
            message: {
                error: {
                    title: '答错了',
                    des: ''
                },
                right: {
                    title: '答对啦!',
                    des: '乾隆的水激式风扇，用活水带动竹板制的风扇转动，将水和风一同吹入宫中，好不凉爽！'
                }
            }
        },
        fifth: {
            order: '第五题',
            testFlag: 5,
            title: '5.哪个朝代的女孩在夏天可以穿得很凉爽？',
            rightChoose: 'a',
            choose: {
                a: '唐朝',
                b: '宋朝',
                c: '清朝'
            },
            message: {
                error: {
                    title: '答错了',
                    des: '偷偷告诉你：女人当权的朝代才能穿的少哦！'
                },
                right: {
                    title: '答对啦!',
                    des: '据说唐朝时期，气温偏高，社会发展繁荣，妇女有机会小露香肩，美美地过夏天。'
                }
            }
        },
        sixth: {
            order: '第六题',
            testFlag: 6,
            title: '6.古代的“华盖”,“羽盖”,“皂盖”中的“盖”是指什么?',
            rightChoose: 'a',
            choose: {
                a: '伞具',
                b: '帽子',
                c: '房顶'
            },
            message: {
                error: {
                    title: '答错了',
                    des: '偷偷告诉你：盖是在手里举着的，大大的遮阳工具。'
                },
                right: {
                    title: '答对啦!',
                    des: '古代皇帝出行时车上的大伞(华盖)可以遮阳和挡雨哦~'
                }
            }
        }
    }
};
